import script from "./OverviewSection.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewSection.vue?vue&type=script&setup=true&lang=js"

import "./OverviewSection.vue?vue&type=style&index=0&id=f48bd6dc&scoped=true&lang=scss"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\161\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f48bd6dc"]])

export default __exports__